<template>
  <TemplateSingleLayout :loaded="!!template" :tabs="tabs">
    <!-- title -->
    <template #template-heading>
      <TemplateDetailsPageHeader :template="template" />
    </template>
    <!-- single tabs -->
    <!-- info -->
    <template #informacion>
      <TemplateDetailsPageSettings :template="template" />
    </template>
    <!-- content -->
    <template #contenido>
      <TemplateDetailsPageContent :template="template" />
    </template>
  </TemplateSingleLayout>
</template>

<script>
// Components
import TemplateSingleLayout from 'Layouts/TemplateSingleLayout'
import TemplateDetailsPageHeader from './components/TemplateDetailsPageHeader'
import TemplateDetailsPageContent from './components/TemplateDetailsPageContent'
import TemplateDetailsPageSettings from './components/TemplateDetailsPageSettings'

export default {
  name: 'TemplatesSingleDetailsPage',

  components: {
    TemplateSingleLayout,
    TemplateDetailsPageHeader,
    TemplateDetailsPageContent,
    TemplateDetailsPageSettings,
  },

  props: {
    temp_id: {
      type: [String, Number],
      required: true,
    },

    temp_title: {
      type: [String, Number],
      default: '',
    },
  },

  data() {
    return {
      tabs: [
        { name: 'Información', slug: 'informacion' },
        { name: 'Contenido', slug: 'contenido' },
      ],
    }
  },

  computed: {
    template() {
      return this.$store.state.templates.templatePublished
    },
  },
}
</script>

<style scoped></style>
